import React from "react";
import { HelpPanel } from "@amzn/awsui-components-console";
import { ExternalLinkGroup } from "../../commons";
import { learnMoreLinks } from "src/pages/commons/learn-more-links";

export function ToolsContent() {
  return (
    <HelpPanel
      header={<h2>View Jem Validation Errors</h2>}
      footer={<ExternalLinkGroup items={learnMoreLinks} />}
    >
      <p>
        View a specific date's Jem Validations or compare with two different
        dates.
      </p>
      <ul>
        <li>Please select date(s) to view or compare.</li>
        <li>
          Note: Comparison will always compare the latest report against a
          previous report.
        </li>
      </ul>
    </HelpPanel>
  );
}
